import { CMSSearchItem } from "./CMSSearchItem";

export default CMSSearchItem;
